import Api from '@common/services/api';
import { APIEvaluationForm, EvaluationFormPayload } from '../types';

export const createPerformanceForm = async (
    organisationId: string,
    payload: EvaluationFormPayload
  ) => {
    return Api.post<{ data: APIEvaluationForm }>(
      `/v1/organisations/${organisationId}/performance/forms`,
      payload
    );
  };
